import $ from 'jquery'
import ListeAnalyse from '@/views/listeAnalyse'
import ListeModelesAnalyse from '@/views/modeles-analyses/liste'
import ParamModeleExamen from '@/views/parametres/configs/param-modele-examen'
import BilanSante from '@/views/parametres/configs/param-bilan-sante'
import ParamAccordionSection from '@/components/param-accordion-section'

export default {
    name: 'laboratoire-imagerie',
    components: {
        ListeAnalyse, ListeModelesAnalyse, ParamModeleExamen, BilanSante, ParamAccordionSection
    },
    props: [],
    data() {
        return {}
    },
    computed: {
        activeRole() {
            return this.$store.getters['activeRole'];
        },
        userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },
    mounted() {
        setTimeout(() => {
            $('.show-on-fixed').fadeIn();
        }, 500);
    },
    methods: {}
}
